import React from 'react';
import SweetLoadingSpinner from '../eyeCandy/SweetLoadingSpinner'

import ProjectCard from "./ProjectCard";
import axios from "axios";

import Config from "../../config/Config.js";

class ProjectsBy extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            loading: true,
            project_list: []
        }
    }
    componentDidMount() {
        axios.get(
            `${Config().projectByTechnologyUrl}${this.props.question}&publish=${this.props.publish}`
        )
        .then(res => {
            const data = res.data;
            this.setState({
              project_list: Array.isArray(data) ? data : data.results || [],
              loading: false
            });
        })
        .catch(err => {
            console.error('ProjectsBy Load Error:', err);
            console.error('ProjectsBy Load Error Response:', err.response);
            console.error('ProjectsBy Load Error Status:', err.response?.status);
            console.error('ProjectsBy Load Error Data:', err.response?.data);
            
            this.setState({
              project_list: [],
              loading: false
            });
        });
    }
    render() {
        return(
            <div
                className="container"
                style={{
                    marginTop: '50px',
                }}
            >
                <h6>{this.props.question} Projects</h6>
                <hr/>
                <SweetLoadingSpinner loadingState={this.state.loading} />
                <div>
                    <div className="row">
                    {this.state.project_list.map(project => {
                        return <ProjectCard project={project} key={project.id} />;
                    })}
                    </div>
                </div>
            </div>
        )
    }
}

export default ProjectsBy;